/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldMap(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldMap',
      'aria-hidden': true,
      focusable: false,
      width:  24 * scale,
      height: 36 * scale,
      viewBox: '0 0 24 36',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"currentColor"},createElement('path', {"d":"M12.01 3A8.99 8.99 0 0 1 21 11.99c0 4.964-3.934 10.733-8.99 19.39-5.055-8.657-8.988-14.426-8.988-19.39A8.99 8.99 0 0 1 12.012 3m0-2C5.95 1 1.02 5.93 1.02 11.99c0 4.786 2.99 9.82 7.127 16.784.68 1.147 1.395 2.35 2.134 3.615l1.73 2.954 1.728-2.958a500 500 0 0 1 2.14-3.623C20.01 21.803 23 16.773 23 11.99 23 5.93 18.07 1 12.01 1z"}),createElement('path', {"d":"M12.02 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-2c-2.205 0-4 1.794-4 4s1.795 4 4 4 4-1.794 4-4-1.793-4-4-4"})))
}
